/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { dateRangeInputBeanSchema } from './dateRangeInputBeanSchema';

export const teamsLookupRequestSchema = z.object({
  get dateRange() {
    return z.union([dateRangeInputBeanSchema, z.null()]).optional();
  },
  expand: z
    .array(z.enum(['MEMBERSHIPS', 'CAPACITY', 'SKILLS', 'OPEN_POSITIONS']))
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    }),
  ids: z.array(z.int()).nullish(),
  loopId: z.int().nullish(),
  skillIds: z.array(z.int()).nullish(),
  teamRoleIds: z.array(z.int()).nullish(),
});
